import { connect } from 'react-redux';
import ContactPage from 'components/pages/ContactPage';
import { selectContactUsRecipients, selectEmailSuccessful } from 'selectors/contactUsSelectors';
import {
  getContactUsRecipients,
  sendContactUsEmail,
} from 'actions/thunks/contactUs';

const mapStateToProps = state => ({
  emailSuccessful: selectEmailSuccessful(state),
  recipients: selectContactUsRecipients(state),
});

const mapDispatchToProps = dispatch => ({
  getContactUsRecipients: () => dispatch(getContactUsRecipients()),
  sendContactUsEmail: (payload) => dispatch(sendContactUsEmail(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactPage);
